@media screen and (min-width: 720px) {
  .cc-items-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
}

@media screen and (min-width: 980px) {
  .cc-items-wrapper {
    margin: -6px;
  }
}

.cc-item {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  min-height: 91px;
  text-decoration: none;
}

.cc-item *,
.cc-item *::before,
.cc-item *::after {
  box-sizing: inherit;
}

@media screen and (max-width: 719px) {
  .cc-item {
    border-bottom: 1px solid #e7e6e6;
  }

  :host(:not([dir="rtl"])) .cc-item {
    padding: 8px 0 8px 8px;
  }

  :host([dir="rtl"]) .cc-item {
    padding: 8px 8px 8px 0;
  }

  .cc-item:first-child {
    border-top: 1px solid #e7e6e6;
  }
}

@media screen and (min-width: 720px) {
  .cc-item {
    display: block;
    position: relative;
    height: auto;
    padding: 8px 8px 12px;
  }
}

@media screen and (min-width: 720px) and (max-width: 980px) {
  .cc-item {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    border-bottom: 1px solid #e7e6e6;
  }

  :host(:not([dir="rtl"])) .cc-item {
    border-right: 1px solid #e7e6e6;
  }

  :host([dir="rtl"]) .cc-item {
    border-left: 1px solid #e7e6e6;
  }

  .cc-item:nth-child(-n+3) {
    border-top: 1px solid #e7e6e6;
  }

  :host(:not([dir="rtl"])) .cc-item:nth-child(3n+1) {
    border-left: 1px solid #e7e6e6;
  }

  :host([dir="rtl"]) .cc-item:nth-child(3n+1) {
    border-right: 1px solid #e7e6e6;
  }
}

@media screen and (min-width: 720px) {
  .cc-item {
    display: block;
    position: relative;
    height: auto;
    padding: 8px 8px 12px;
  }

  .cc-item--favorite.cc-item--disable {
    background-color: #fafafa;
  }

  .cc-item--favorite:not(.cc-item--disable) {
    border-color: #3dcd58;
  }

  .cc-item--favorite:not(.cc-item--disable) .cc-item__icon--favorite {
    color: #3dcd58;
  }

  .cc-item--favorite .cc-item__icon--favorite {
    display: block;
  }
}

@media screen and (min-width: 980px) {
  .cc-item {
    flex-basis: calc(25% - 12px);
    max-width: calc(25% - 12px);
    margin: 6px;
    border: 1px solid #e7e6e6;
  }

  .cc-item:hover {
    box-shadow: 0 7px 15px 0 rgba(51, 51, 51, 0.2);
  }
}

.cc-item:focus {
  outline: 2px solid #e7e6e6;
}

.cc-item__icon {
  color: rgba(51, 51, 51, 0.5);
}

@media screen and (min-width: 720px) {
  .cc-item__icon {
    position: absolute;
    height: 16px;
  }
}

@media screen and (min-width: 980px) {
  .cc-item__icon {
    display: none;
  }

  .cc-item:hover .cc-item__icon {
    display: block;
  }
}

.cc-item__icon--favorite {
  align-self: center;
  background: none;
  border: none;
  cursor: pointer;
}

.cc-item__icon--favorite:focus {
  outline: 2px solid #e7e6e6;
}

@media screen and (max-width: 719px) {
  .cc-item__icon--favorite {
    width: 32px;
    height: 32px;
    padding: 8px;
  }

  .cc-item__icon--favorite:focus {
    outline: 0;
  }
}

@media screen and (min-width: 720px) {
  .cc-item__icon--favorite {
    width: 16px;
    height: 16px;
    padding: 0;
    top: 10px;
  }

  :host(:not([dir="rtl"])) .cc-item__icon--favorite {
    right: 11px;
  }

  :host([dir="rtl"]) .cc-item__icon--favorite {
    left: 11px;
  }
}

.cc-item__icon--new-window {
  height: 16px;
  align-self: flex-end;
}

@media screen and (min-width: 720px) {
  .cc-item__icon--new-window {
    bottom: 6px;
  }

  :host(:not([dir="rtl"])) .cc-item__icon--new-window {
    left: 7px;
  }

  :host([dir="rtl"]) .cc-item__icon--new-window {
    right: 7px;
  }
}

.cc-item__logo {
  width: 114px;
  margin-left: 10px;
  margin-right: 10px;
}

@media screen and (min-width: 720px) {
  .cc-item__logo {
    margin: 0 auto;
    height: 70px;
    text-align: center;
  }
}

.cc-item__logo img {
  max-width: 114px;
  max-height: 70px;
  vertical-align: top;
}

.cc-item--favorite.cc-item--disable .cc-item__logo img {
  opacity: 0.5;
}

.cc-item__info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  font-size: 12px;
  line-height: 20px;
}

@media screen and (max-width: 979px) {
  :host(:not([dir="rtl"])) .cc-item__info {
    margin-left: auto;
  }

  :host([dir="rtl"]) .cc-item__info {
    margin-right: auto;
  }
}

@media screen and (min-width: 720px) {
  .cc-item__info {
    margin-top: 8px;
    align-items: center;
  }
}

.cc-item__stock {
  line-height: 20px;
  padding-left: 5px;
  padding-right: 5px;
  color: #626469;
  background-color: rgba(98, 100, 105, 0.1);
}

@media screen and (min-width: 720px) {
  .cc-item__stock {
    text-align: center;
  }
}

.cc-item__stock--in {
  color: #3dcd58;
  background-color: rgba(61, 205, 88, 0.1);
}

.cc-item__price {
  margin-top: 8px;
  color: #626469;
  font-weight: bold;
}

@media screen and (min-width: 980px) {
  .cc-item__price {
    flex-grow: 1;
  }

  :host(:not([dir="rtl"])) .cc-item__price {
    text-align: right;
  }

  :host([dir="rtl"]) .cc-item__price {
    text-align: left;
  }
}